import { render, staticRenderFns } from "./template_point_conf.vue?vue&type=template&id=8205c2dc&"
import script from "./template_point_conf.vue?vue&type=script&lang=js&"
export * from "./template_point_conf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports